<div class="flex-vertical gap-24 height-100pc">
  <div class="flex-horizontal">

    @if (!isInstanceMode) {
      @if (!editNC) {
        <h6>Ajouter une non-conformité</h6>
      } @else {
        <h6>{{ isInstanceMode ? 'Modifier une instance partenaire' : 'Modifier une non-conformité' }}</h6>
      }
    } @else {
      @if (!editNC) {
        <h6>Ajout d'une instance partenaire</h6>
      } @else {
        <h6>{{ isInstanceMode ? 'Modifier une instance partenaire' : 'Modifier une non-conformité' }}</h6>
      }
    }




  </div>
  <div class="flex-vertical gap-16 flex-1">
    <oui-select label="Catégorie" [options]="categoriesList" [control]="categoryControl"></oui-select>
    <oui-select label="Motif" [options]="motifsList" [control]="motifControl"></oui-select>
    <div class="flex-vertical flex-1">
      <oui-textarea
        class="height-100pc"
        label="Commentaire"
        [control]="commentaireControl"
      placeholder="Commentaire"></oui-textarea>
    </div>
  </div>
  @if (isInstanceMode) {
    <oui-slide-toggle
      label="Instance à traiter en interne"
      (checkedChange)="onSetInternalChange($event)"
      [checked]="!!editNC?.isInternal">
    </oui-slide-toggle>
  }
  <div class="flex-horizontal gap-16">
    <div><oui-button type="text" (click)="onCancel()">Annuler</oui-button></div>
    @if (!editNC) {
      <div class="flex-1">
        <oui-button [disabled]="!isValid()" (click)="onAdd()" class="width-100pc">Ajouter</oui-button>
      </div>
    } @else {
      <div class="flex-1">
        <oui-button [disabled]="!isValid()" (click)="onEdit()" class="width-100pc">Valider</oui-button>
      </div>
    }
  </div>
</div>
